import DataDog from '../Helpers/DataDog';
import ApiService from './ApiService';

const logsEvent = (context, e) => {
    DataDog.trackCustomEvent('registrar-domicilio', {
        datos: e.dataDomicilio,
    });
    DataDog.trackCustomEvent('vincular-credencial', {
        canalDeVenta: context?.canalDeVenta,
        formaDeContacto: context?.formaDeContacto,
        planId: context?.planCampania?.id,
    });
};

const logsEventWarning = (context, e, data, error) => {
    DataDog.trackCustomEventWarning('error-registrar-domicilio', {
        datos: e.dataDomicilio,
        code: data?.code,
        error: error !== null ? error : data.message,
    });
    DataDog.trackCustomEventWarning('error-vincular-credencial', {
        canalDeVenta: context?.canalDeVenta,
        formaDeContacto: context?.formaDeContacto,
        planId: context?.planCampania?.id,
        code: data?.code,
        error: error !== null ? error : data.message,
    });
};

export const guardarDomicilio = (context, e) => {
    const { REACT_APP_APIPAYWALL } = process.env;
    return ApiService.post(`${REACT_APP_APIPAYWALL}Domicilio/PosdatarDomicilio`, e.dataDomicilio)
        .then((data) => {
            if (data && data.code === '0000') {
                logsEvent(context, e);
                DataDog.addGlobalContext(context, context.planCampania.planes[0].detalles[0].familiaProducto.nombre, true);
                return Promise.resolve(data);
            } else {
                logsEventWarning(context, e, data);
            }
        })
        .catch((error) => {
            logsEventWarning(context, e, null, error);
            return Promise.reject(error);
        });
};
